import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';
import { DatePipe } from '@angular/common';

/**
 * @ngModule SharedModule
 * @whatItDoes Formats a date after converting it to EST/EDT.
 * @description
 * This pipe works just like the built-in DatePipe, but first converts the date to EST.
 */
@Pipe({
  name: 'dateEst'
})
export class DateEstPipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) private readonly _locale: string, private readonly _datePipe: DatePipe) {
    moment.locale(_locale);
  }

  private static _addLeadingZero(amount: number) {
    if (amount < 10) {
      return '0' + amount;
    }

    return amount.toString();
  }

  /**
   * Transform operator of the pipe.
   */
  transform(value: any, format?: string): string {
    const time = moment.tz(value, 'America/New_York');
    let offset = time.utcOffset();
    const negative = offset < 0;
    offset = Math.abs(offset);
    const hours = Math.floor(offset / 60);
    const minutes = offset % 60;

    const offsetText = (negative ? '-' : '+')
      + DateEstPipe._addLeadingZero(hours)
      + DateEstPipe._addLeadingZero(minutes);

    return this._datePipe.transform(value, format, offsetText);
  }
}
